import type { ContentPack } from '../types';
import { CATEGORIES, STAT_DEFS } from './categories';
import { monsterComputeStats } from './stats';
import { wolf } from './species/wolf';
import { dragon } from './species/dragon';
import { slime } from './species/slime';
import { bird } from './species/bird';
import { golem } from './species/golem';
import { cranium } from './parts/cranium';
import { back } from './parts/back';
import { tail } from './parts/tail';
import { drawMonsterBackground } from './worlds';

export const monstersPack: ContentPack = {
  id: 'monsters',
  version: 1,
  metadata: {
    title: 'SPRITE: MONSTERS',
    namingLabel: 'Monster',
    filePrefix: 'sprite-monster',
    baseCategoryId: 'hull',
  },
  colorLabels: { primary: 'Body', accent: 'Markings', glow: 'Aura', detail: 'Eyes', trim: 'Claws' },
  rasterSize: 64,
  hulls: { wolf, dragon, slime, bird, golem },
  parts: { ...cranium, ...back, ...tail },
  categories: CATEGORIES,
  stats: STAT_DEFS,
  compositeSlots: {},
  renderOrder: ['hull', 'cranium', 'back', 'tail'],
  computeStats: monsterComputeStats,
  drawBackground: drawMonsterBackground,
  defaultBuild: {
    hull: 'wolf',
    cranium: 'horns',
    back: 'spikes',
    tail: 'wolf_tail',
    world: 'forest',
  },
};
